import { EApplicationStatus } from '@/interfaces'
import {
  ApplicationsState,
  AuthState,
  ConvocatoriasState,
  OfflineState,
} from '@/state'
import { applicationsStateActions } from '@/state/actions'
import { useComputed } from '@preact/signals-react'
import { Button, Tooltip } from 'antd'
import { BiImport } from 'react-icons/bi'
import ImportModal from './modal'

export default function ImportApplications() {
  const canShowImportAction = useComputed(() => {
    const hasAccess = AuthState.statusChangeAllowed.value.includes(
      EApplicationStatus.IMPORT
    )
    const hasTypeOptions = Boolean(
      ConvocatoriasState.currentConvocatoria.value.appType?.length
    )
    const convocatoriaIsActive =
      ConvocatoriasState.currentConvocatoria.value.isActive

    return hasAccess && hasTypeOptions && convocatoriaIsActive
  })

  if (canShowImportAction.value)
    return (
      <Tooltip title='Importar data de convocatoria' placement='left'>
        <Button
          className='import-btn'
          shape='circle'
          icon={<BiImport size={16} />}
          loading={ApplicationsState.loading.value.import}
          onClick={applicationsStateActions.openImportModal}
          disabled={
            ApplicationsState.loading.value.getAll ||
            ApplicationsState.loading.value.import ||
            OfflineState.isSynchronizing.value
          }
        />
        <ImportModal />
      </Tooltip>
    )
}
